import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { WidgetType } from "../Enums/WidgetType";
import { ElementHelper } from "../Helpers/ElementHelper";
import { LabelFilter } from "../Models/LabelFilter";
import { MultipleFilterModel } from "../Models/MultipleFilterModel";
import { FiltersManager } from "./FiltersManager";

export class ChallengeWidgetManager {

    constructor(private containerElement: JQuery) {
    }

    public filtersManager : FiltersManager;

    public initialize() {

        let self = this;

        this.filtersManager = new FiltersManager(this.containerElement.find('.filter-container'), WidgetType.ChallengeWidget);
        this.filtersManager.initialize();

        this.filtersManager.onFiltersChange.subscribe((sender, result) => {
            self.loadChallenges(result.searchString, result.sortOrderString, result.simpleFilters, result.multipleFilters);
        })

        $('#search-challenges-form').each((index, element) => {
            var searchForm = $(element);
            searchForm.on('submit', () => {
                this.loadChallenges(searchForm.find('#search').val()?.toString() ?? "", undefined, undefined, undefined)
            })
        })

        var initialFilters = this.filtersManager.getFilters();
        self.loadChallenges(initialFilters.searchString, initialFilters.sortOrderString, initialFilters.simpleFilters, initialFilters.multipleFilters);
    }

    loadChallenges(search: string, sortOrder: string | undefined, simpleFilters : string[] | undefined, multipleFilters : MultipleFilterModel[] | undefined) {
        var self = this;
        let pageNumber = 1;

        var challengeListItems = this.containerElement.find('[data-challenge-list-id]');

        var amountOfItems = challengeListItems.length;
        var totalNumberOfItems = 0;
        var labelFilters : LabelFilter[];
        var filterCountIndex = 0;

        var setFilterCount = () => {
            if(filterCountIndex == amountOfItems-1 && labelFilters != undefined) {
                self.filtersManager.setFiltersCount(totalNumberOfItems, labelFilters);
                labelFilters == undefined;
                filterCountIndex = 0;

                var noResultContainers = this.containerElement.find('.no-results-for-filter-container');
                var amountOfNoResults = noResultContainers.length;

                if(amountOfNoResults > 0 && amountOfNoResults != amountOfItems) {
                    noResultContainers.remove();
                }
                else {
                    noResultContainers.removeClass('d-none');
                }
            }

            filterCountIndex++;
        }

        if(amountOfItems == 0) {
            ElementHelper.bindListWithShowMore(this.containerElement);
            ElementHelper.bindListItemsWithHref(this.containerElement);
            ElementHelper.reformatCardContentHeight(this.containerElement);
        }

        challengeListItems.each((index, element) => {  
            var challengeListElement = $(element);
            challengeListElement.html('<div class="btn-spinner"></div>')
        });

        async function processChallenges(): Promise<void> {
            for (const element of challengeListItems.toArray()) {

                var challengeListElement = $(element);

                let challengeId = challengeListElement.data('challenge-id');
                if (challengeId == undefined) {
                    challengeId = '';
                }

                let type = challengeListElement.data('type');
                if (type == undefined) {
                    type = '';
                }
        
                let organizationId = challengeListElement.data('organization-id');
                if (organizationId == undefined) {
                    organizationId = '';
                }
        
                let challengeGroupId = challengeListElement.data('challenge-group-id');
                if (challengeGroupId == undefined) {
                    challengeGroupId = '';
                }

                let maxNumber = challengeListElement.data('max-number');
                if (maxNumber == undefined) {
                    maxNumber = '';
                }
                
                let active = challengeListElement.data('active');
                if (active == undefined) {
                    active = '';
                }
        
                let expired = challengeListElement.data('expired');
                if (expired == undefined) {
                    expired = '';
                }
        
                let hideLinkText = challengeListElement.data('hide-link-text');
                if (hideLinkText == undefined) {
                    hideLinkText = '';
                }
        
                let hideOrganizationLogo = challengeListElement.data('hide-organization-logo');
                if (hideOrganizationLogo == undefined) {
                    hideOrganizationLogo = '';
                }
        
                let randomSort = challengeListElement.data('random-sort');
                if (randomSort == undefined) {
                    randomSort = '';
                }
        
                let showMoreText= challengeListElement.data('show-more-text');
                if (showMoreText == undefined) {
                    showMoreText = '';
                }
        
                let contentAlign= challengeListElement.data('content-align');
                if (contentAlign == undefined) {
                    contentAlign = '';
                }
        
                if (search == undefined) {
                    search = '';
                }
        
                let hideReward = challengeListElement.data('hide-reward');
                if (hideReward == undefined) {
                    hideReward = '';
                }
        
                let hideDeadline = challengeListElement.data('hide-deadline');
                if (hideDeadline == undefined) {
                    hideDeadline = '';
                }
        
                let openChallengesInNewWindow = challengeListElement.data('open-challenges-in-new-window');
                if (openChallengesInNewWindow == undefined) {
                    openChallengesInNewWindow = '';
                }
        
                let blockId = challengeListElement.data('block-id');
        
                let amountOfChallengesInShowMoretext = challengeListElement.data('show-amount-of-challenges-in-show-more-text');
                if (amountOfChallengesInShowMoretext == undefined) {
                    amountOfChallengesInShowMoretext = '';
                }

                challengeListElement.html('<div class="btn-spinner"></div>')
        
                await $.post(`/challenge/challengeslist`,
                {
                    'pageNumber' : pageNumber,
                    'type': type,
                    'organizationId' : organizationId,
                    'challengeId' : challengeId,
                    'maxNumber' : maxNumber,
                    'challengeGroupId' : challengeGroupId,
                    'active' : active,
                    'hideOrganizationLogo' : hideOrganizationLogo,
                    'search' : search,
                    'expired' : expired,
                    'randomSort' : randomSort,
                    'showMoreText' : showMoreText,
                    'contentAlign' : contentAlign,
                    'hideLinkText' : hideLinkText,
                    'hideReward' : hideReward,
                    'hideDeadline' : hideDeadline,
                    'openChallengesInNewWindow' : openChallengesInNewWindow,
                    'blockId' : blockId,
                    'showAmountOfChallengesInShowMoreText' : amountOfChallengesInShowMoretext,
                    'sortOrder' : sortOrder,
                    'simpleFilters' : simpleFilters,
                    'multipleFilters' : multipleFilters,
                    "__RequestVerificationToken": (window as any).getToken()
                },
                function(data){
                    challengeListElement.html(data.view);

                    Swiper.use([Navigation, Pagination, Autoplay]);

                    challengeListElement.find('.swiper-spotlight').each((index, element) => {

                        var parsedSwiperElement = $(element);
                        var amountOfItems = +parsedSwiperElement.data('amount-of-items');
                        const spotlightSwiper = new Swiper(element,
                            {
                                // Optional parameters
                                direction: 'horizontal',
                                loop: true,
                                slidesPerView: 'auto',
                                spaceBetween: 0,
                                breakpoints: {
                                    0: {
                                        centeredSlides: true,
                                    },  
                                    576: {
                                        centeredSlides: false,
                                    },
                                    992: {
                                        loop: amountOfItems >= 3 ? true : false,
                                        
                                    },
                                },

                                pagination: {
                                    el: amountOfItems >= 3 ? challengeListElement.find('.swiper-pagination')[0] : undefined,
                                },

                                navigation: {
                                    nextEl: challengeListElement.find('.swiper-button-next')[0],
                                    prevEl: challengeListElement.find('.swiper-button-prev')[0],
                                    disabledClass: amountOfItems > 3 || amountOfItems < 3 ? 'disabled_swiper_button' : undefined
                                },
                            });
                    });

                    totalNumberOfItems+= +data.totalNumberOfItems;

                    if(data.labelFilters != null || data.labelFilters != undefined) {
                        if(labelFilters == undefined) {
                            labelFilters = data.labelFilters;
                            setFilterCount();
                        }
                        else {
                            data.labelFilters.forEach((childLabel : LabelFilter, index) => {
                                var labelFilter = labelFilters.find(x => x.id == childLabel.id);
                                if(labelFilter == undefined) {
                                    labelFilters.push(childLabel);
                                }
                                else {
                                    labelFilter.amountOfItemsForLabel += childLabel.amountOfItemsForLabel;
                                }
                            })

                            setFilterCount();
                        }
                    }

                    let showMoreBtn = challengeListElement.find('#btn-show-more');

                    ElementHelper.bindListWithShowMore(challengeListElement);
                    ElementHelper.bindListItemsWithHref(challengeListElement);
                    ElementHelper.reformatCardContentHeight(challengeListElement);

                    if (<boolean>(data.hasMorePages) == false) {
                        
                        showMoreBtn.hide();
                    }
                    else {
                        showMoreBtn.click((e) => {
                            showMoreBtn.find('.btn-spinner').removeClass('d-none');
                            e.preventDefault();

                            pageNumber += 1;

                            $.post(`/challenge/challengeslist`,
                            {
                                'pageNumber' : pageNumber,
                                'type': type,
                                'organizationId' : organizationId,
                                'challengeId' : challengeId,
                                'maxNumber' : maxNumber,
                                'challengeGroupId' : challengeGroupId,
                                'active' : active,
                                'hideOrganizationLogo' : hideOrganizationLogo,
                                'search' : search,
                                'expired' : expired,
                                'randomSort' : randomSort,
                                'showMoreText' : showMoreText,
                                'contentAlign' : contentAlign,
                                'hideLinkText' : hideLinkText,
                                'hideReward' : hideReward,
                                'hideDeadline' : hideDeadline,
                                'openChallengesInNewWindow' : openChallengesInNewWindow,
                                'blockId' : blockId,
                                'showAmountOfChallengesInShowMoreText' : amountOfChallengesInShowMoretext,
                                'simpleFilters' : simpleFilters,
                                'multipleFilters' : multipleFilters,
                                'sortOrder' : sortOrder,
                                "__RequestVerificationToken": (window as any).getToken()
                            },
                            function(data){
                                showMoreBtn.find('.btn-spinner').addClass('d-none');

                                var challengeListToAppendTo = showMoreBtn.closest('[data-challenge-list-id]');

                                challengeListToAppendTo.children().first().append(data.view);

                                ElementHelper.bindListWithShowMore(challengeListToAppendTo);
                                ElementHelper.bindListItemsWithHref(challengeListToAppendTo);
                                ElementHelper.reformatCardContentHeight(challengeListToAppendTo);

                                if (<boolean>(data.hasMorePages) == false) {
                                    showMoreBtn.hide();
                                }
                                else {
                                    var showMoreText = <string>(data.showMoreText);
                                    if(showMoreText.length >= 1) {
                                        showMoreBtn.find('#btn-show-more-text').text(showMoreText);
                                    }
                                }
                            });
                        });
                    }
                });
            }
        }

        void processChallenges();
    }
}